export default __webpack_public_path__ + "static/media/qr black.5500a9c3.png";